<nav class="navbar navbar-dark bg-primary">
    <pace-core-side-menu></pace-core-side-menu>
    <a class="navbar-brand mt-2" href="#" translate="HEADER_TITLE"></a>
    <span class="navbar-text ms-auto">{{ appVersion }}</span>
</nav>
